module.exports = __webpack_public_path__ + "static/media/wifimedia-logo-300x122.b56a2a5d.png";